import type { CountdownRendererFn } from 'react-countdown';

export const renderTimeAfterDays: CountdownRendererFn = ({ formatted, days }) => {
  const { hours, minutes, seconds } = formatted;

  if (days > 0) {
    return `${days} Days`;
  }

  return `${hours}:${minutes}:${seconds}`;
};
